import type { Dataset, StoreRecord } from "./types";

export async function loadDataset(): Promise<Dataset> {
  const response = await fetch(`${import.meta.env.BASE_URL}data.json`, { cache: "no-cache" });
  if (!response.ok) {
    throw new Error(`料金データを読み込めませんでした（HTTP ${response.status}）`);
  }
  return (await response.json()) as Dataset;
}

/** 店舗名から店舗情報（確認日・規則）を引けるようにする。 */
export function indexStores(dataset: Dataset): Map<string, StoreRecord> {
  return new Map(dataset.stores.map((store) => [store.name, store]));
}

/**
 * 店舗規則の one_order からワンオーダーの金額を取り出す。
 * 例: "室料とは別に451円（税込）以上のドリンク1品" -> 451
 */
export function buildDrinkCosts(dataset: Dataset): Record<string, number> {
  const costs: Record<string, number> = {};
  for (const store of dataset.stores) {
    const rule = store.rules.find((item) => item.key === "one_order");
    if (!rule || typeof rule.value !== "string") continue;
    const match = /(\d[\d,]*)\s*円/.exec(rule.value);
    if (match) costs[store.name] = Number(match[1].replace(/,/g, ""));
  }
  return costs;
}

/** データ全体の基準日（確認日・取得日のうち最も新しいもの）。 */
export function dataAsOf(dataset: Dataset): string | null {
  const dates: string[] = [];
  for (const store of dataset.stores) {
    for (const value of [store.source.checkedAt, store.source.fetchedAt]) {
      if (value) dates.push(value);
    }
  }
  if (dates.length === 0) return null;
  return dates.sort().at(-1) ?? null;
}
